import React from 'react';
import ReactDOM from 'react-dom';
import { ClassMates } from './ClassMates';
import './styles/styles.scss';

ReactDOM.render(
    <ClassMates />,
  document.getElementById('root')
);
